import CreateAction from "./create";
import RecordAction from "./record";
import ViewAction from "./view";

const AddActions = () => {
  return (
    <div className="flex items-center gap-4">
      <CreateAction />
      <ViewAction />
      <RecordAction />
    </div>
  );
};

export default AddActions;
